export default __webpack_public_path__ + "static/media/icon-feather-chevron-right.fcb6c50e.svg";